import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const getCookies = ({ name }) => cookies.get(name);
export const setCookies = ({ name, value, options = {} }) => cookies.set(name, value, options);
export const removeCookies = ({ name }) => cookies.remove(name);

